import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { RecruitersRequest, RecruitersResponse } from "./types";

export const recruiters = (data?: RecruitersRequest): AxiosPromise<RecruitersResponse> => axiosInstance.post(`/recruiters`, data);
